import { Skeleton, styled, useTheme, useMediaQuery } from '@ori-ui/mui';
import type { FC } from 'react';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const StepLogo = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(2),
}));

const StepTitle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(4),
}));

const StepSubTitle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(3),
}));

const StepContent = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(6),
}));

export const BasicSkeleton: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Root>
      <StepLogo>
        <Skeleton
          height={56}
          width={isMobile ? 253 : 273}
          variant="rectangular"
          animation="wave"
          sx={{ borderRadius: 1 }}
        />
      </StepLogo>
      <StepTitle>
        <Skeleton
          height={33}
          width={isMobile ? 300 : 352}
          variant="rectangular"
          animation="wave"
          sx={{ borderRadius: 1 }}
        />
      </StepTitle>
      <StepSubTitle>
        <Skeleton
          height={73}
          width={isMobile ? 320 : 542}
          variant="rectangular"
          animation="wave"
          sx={{ borderRadius: 1 }}
        />
      </StepSubTitle>
      <StepContent>
        <Skeleton
          height={178}
          width={isMobile ? 320 : 542}
          variant="rectangular"
          animation="wave"
          sx={{ borderRadius: 1 }}
        />
      </StepContent>
      <Skeleton
        height={56}
        width={isMobile ? 290 : 347}
        variant="rectangular"
        animation="wave"
        sx={{ borderRadius: 1 }}
      />
    </Root>
  );
};
